import React from "react";
import { ImportValidationModal } from "../../../ImportValidationModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const ImportValidationModalWrapper: React.FC = () => {
  const { data, modals, props } = useClarificationsRegisterContext();
  const { clarificationTypes } = data;
  const { validationResult, isValidationModalOpen, setIsValidationModalOpen, setValidationResult, handleConfirmImport } = modals;
  const { rfxSubmissionId } = props;

  if (!validationResult) return null;

  return (
    <ImportValidationModal
      isOpen={isValidationModalOpen}
      onClose={() => {
        setIsValidationModalOpen(false);
        setValidationResult(null);
      }}
      onImport={handleConfirmImport}
      validationResult={validationResult}
      clarificationTypes={clarificationTypes}
      rfxSubmissionId={rfxSubmissionId || 0}
    />
  );
};
